import styled, {keyframes} from "styled-components";


export const Container = styled.div`
    background-image: url(${props => props.background});
    z-index: 11;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-size: cover;
    background-repeat: no-repeat;
`

const BallShake = keyframes`
  0%,
  100% {
    -webkit-transform: translateX(0%);
            transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
            transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
            transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
            transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
            transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
            transform: translateX(-6px) rotate(-1.2deg);
  }
`

export const PokeBallClose = styled.img`
    width: 35vw;
    margin-top: 60vh;
    filter: drop-shadow(-20px 30px 15px rgba(0, 0, 0, 0.2)); 
    animation-name: ${BallShake};
    animation-duration: 1s;
    animation-iteration-count: infinite;

`
export const PokeBallOpen = styled.img`
    width: 35vw;
    margin-top: 5vh;
    filter: drop-shadow(-20px 30px 15px rgba(0, 0, 0, 0.2)); 
`

export const CardLoot = styled.div`
    width: 90vw;
    background-color: white;
    border-radius: 25px;
    height: auto;
    margin-top: 5vh;
    box-shadow: 0px -1px 18px -6px rgba(0,0,0,0.49);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 5%;
`

export const ButtonContainer = styled.div`
    margin-top: 5%;
`


const Blink = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

export const BlinkDiv = styled.div`
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: white;
    animation-name: ${Blink};
    animation-duration: 1s;
    animation-iteration-count: initial;
    animation-fill-mode: forwards;
`